import { dashboardService } from '@/services/dashboard/DashboardService';

export interface OnlineCountResponse { count: number }

export class PresenceService {
  static async heartbeat(): Promise<void> {
    // Use dashboard pulse to update last_seen and also return presence snapshot
    await dashboardService.pulse({ include: 'presence', heartbeat: true, perPage: 1 });
  }

  static async getOnlineCount(regionId?: number | null): Promise<number> {
    const pulse = await dashboardService.pulse({ regionId: regionId ?? undefined, include: 'presence', perPage: 1 });
    return pulse.presence?.online_count ?? 0;
  }

  static async getOnlineList(regionId?: number | null): Promise<Array<{ id: number; name?: string | null; team_name?: string | null; region_id?: number | null; region_name?: string | null; last_seen_at?: string | null }>> {
    const pulse = await dashboardService.pulse({ regionId: regionId ?? undefined, include: 'presence', perPage: 500 });
    const list = (((pulse as any).presence?.online_users) ?? []) as Array<any>;
    return list.map((u: any) => ({
      id: Number(u?.id ?? 0),
      name: typeof u?.name === 'string' ? u.name : null,
      team_name: typeof u?.team_name === 'string' ? u.team_name : null,
      region_id: typeof u?.region_id === 'number' ? u.region_id : (typeof u?.region?.id === 'number' ? u.region.id : null),
      region_name: typeof u?.region_name === 'string' ? u.region_name : (typeof u?.region?.name === 'string' ? u.region.name : null),
      last_seen_at: typeof u?.last_seen_at === 'string' ? u.last_seen_at : null,
    }));
  }
}

export default PresenceService;
